import axios from '../utils/axios';

export default function fetchPaidJobs(adminId, params) {
    return (
        axios.get('/admin/' + adminId + '/paid-jobs', {
            params: params
        })
            .then(res => {
                return res.data
            })
            .catch(err => {
                return err;
            })
    )
}
